import React, { useState, useEffect, useMemo } from "react";
import DataGrid, {
  Column,
  Export,
  FilterRow,
  HeaderFilter,
  FilterPanel,
  Selection,
  Scrolling,
  LoadPanel,
  SearchPanel,
  ColumnChooser,
  ColumnChooserSearch,
  ColumnChooserSelection,
  Position,
  Paging,
  Pager,
  MasterDetail,
} from "devextreme-react/data-grid";
import Button1 from "@material-ui/core/Button";
import CustomStore from "devextreme/data/custom_store";
import { Workbook } from "exceljs";
import { saveAs } from "file-saver-es";
import { exportDataGrid } from "devextreme/excel_exporter";
import "whatwg-fetch";
import { useStyles } from "../../Styles.js";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import { api_path } from "../../shared.js";
import Select from "react-select";
import { useNavigate } from "react-router";
import DateBox from "devextreme-react/date-box";
import axios from "axios";
import swal from "sweetalert";
import dateFormat, { masks } from "dateformat";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import Modal from "react-bootstrap/Modal";
import TextField from "@material-ui/core/TextField";
import "../../styles/Activity.css";
import AddAssetModal from "./AddAssetModal.js";
//import SaleActivityMasterDetailView from "./SaleActivityMasterDetailView";
import LicensesSummaryPage from "./LicensesSummaryPage.js";
export function TicketManagementDatagrid(props) {
  const classes = useStyles();
  const token = process.env.REACT_APP_API_TOKEN;
  const [getCrmId, setCrmId] = useState(props.CRM_ID);
  const [getUserRole, setUserRole] = useState(props.USER_ROLE);
  const [getUserID, setUserID] = useState(props.USER_EMAIL);
  const [getEmpCode, setEmpCode] = useState(props.EMP_CODE);
  const [getTeam, setTeam] = useState([]);
  const [getSelectTeam, setSelectTeam] = useState([]);
  const [getSale, setSale] = useState([]);
  const [saleList, setSaleList] = useState([]);
  const [getSelectSale, setSelectSale] = useState([]);
  const [getType, setType] = useState([]);
  const [getSearchStatus, setSearchStatus] = useState(0);
  const [getLoadGrid, setLoadGrid] = useState();
  const [getTotalCount, setTotalCount] = useState(0);
  const [GET_SERIAL, SET_SERIAL] = useState();
  const [getResult, setResult] = useState("");
  const pageSizes = [25, 50, 100];
  const [getDateStr, setDateStr] = useState(
    "Please click Search button to refresh data."
  );
  const [customer, setCustomer] = useState([]);
  const [selectCustomer, setSelectCustomer] = useState([]);
  const [customerList, setCustomerList] = useState([]);
  const [getStatus, setStatus] = useState([]);
  const [selectStatus, setSelectStatus] = useState([]);
  const [selectedStage, setSelectedStage] = useState(null);
  const now = new Date();
  const dateLabel = { "aria-label": "Date" };
  var date = new Date();
  var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
  var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  const formattedfirstDay = firstDay
    .toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
    .split("/")
    .reverse()
    .join("-");

  const formattedlastDay = lastDay
    .toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
    .split("/")
    .reverse()
    .join("-");

  const [getDateFrom, setDateFrom] = useState(formattedfirstDay);
  const [getDateTo, setDateTo] = useState(formattedlastDay);
  const [getMinDate, setMinDate] = useState(null);
  const [showSelect, setShowSelect] = useState(false);
  const navigate = useNavigate();
  const statusList = [
    { value: "1", label: "Telesales" },
    { value: "2", label: "Sales Visit" },
    { value: "3", label: "Quotation" },
    { value: "8", label: "Follow-up" },
  ];
  // const salesActivityDataSource = useMemo(() => {
  //   return new CustomStore({
  //     key: "SALES_ACTIVITY_ID",
  //     load: async (loadOptions) => {
  //       const skip = loadOptions.skip ?? 0;
  //       const take = loadOptions.take ?? 5000;
  //       const pageIndex = Math.floor(skip / take) + 1;

  //       const sortField = loadOptions.sort?.[0]?.selector ?? "ACTIVITY_DATE";
  //       const sortOrder =
  //         loadOptions.sort?.[0]?.desc !== false ? "DESC" : "ASC";

  //       const params = new URLSearchParams({
  //         CRM_UID: getCrmId,
  //         CRM_CUSCODE: selectCustomer,
  //         ROLE_ID: getUserRole,
  //         ACTIVITY_TYPE: selectedStage || selectStatus,
  //         DATE_FROM: getDateFrom,
  //         DATE_TO: getDateTo,
  //         SALES_CODE: getSelectSale,
  //         SALES_TEAM: getSelectTeam,
  //         PageIndex: pageIndex,
  //         PageSize: take,
  //         SortField: sortField,
  //         SortOrder: sortOrder,
  //         load: getLoadGrid,
  //       }).toString();

  //       const response = await fetch(
  //         `${api_path}/customer/customer_activities.php?${params}`,
  //         {
  //           headers: { Authorization: `Bearer ${token}` },
  //         }
  //       );

  //       const result = await response.json();

  //       return {
  //         data: result.data ?? [],
  //         totalCount: result.totalCount ?? 0,
  //       };
  //     },
  //   });
  // }, [
  //   getCrmId,
  //   getUserRole,
  //   selectStatus,
  //   selectCustomer,
  //   getDateFrom,
  //   getDateTo,
  //   api_path,
  //   token,
  //   selectedStage,
  //   getUserRole,
  //   getSelectSale,
  //   getSelectTeam,
  //   getLoadGrid,
  // ]);

  const onValueChangedDateFrom = React.useCallback((e) => {
    setSearchStatus(0);
    const dateFrom = new Date(e.value);
    const formattedDateFrom = dateFrom
      .toLocaleDateString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .split("/")
      .reverse()
      .join("-");
    setDateFrom(formattedDateFrom);
    setMinDate(formattedDateFrom);
  }, []);
  const onValueChangedDateTo = React.useCallback((e) => {
    setSearchStatus(0);
    const dateTo = new Date(e.value);
    const formattedDateTo = dateTo
      .toLocaleDateString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .split("/")
      .reverse()
      .join("-");
    setDateTo(formattedDateTo);
  }, []);
  function formatDate(value) {
    let date = new Date(value);
    const day = date.toLocaleString("default", { day: "2-digit" });
    const month = date.toLocaleString("default", { month: "short" });
    const year = date.toLocaleString("default", { year: "numeric" });
    return day + "-" + month + "-" + year;
  }
  const handleSearch = (e) => {};
  const [resetSignal, setResetSignal] = useState(false);
  const handleClearInputClick = () => {
    setDateStr("Please click Search button to refresh data.");
    setSearchStatus(0);
    setCustomer([]);
    setSelectCustomer([]);
    setStatus([]);
    setSelectStatus([]);
    setDateFrom(formattedfirstDay);
    setDateTo(formattedlastDay);
    setResult("");
    setDateStr("");
    setTotalCount(0);
    setSelectedStage(null);
    setResetSignal((prev) => !prev); // toggle เพื่อ trigger useEffect ใน child
    setTeam([]);
    setSelectTeam([]);
  };
  const columnChooserModes = [
    {
      key: "dragAndDrop",
      name: "Drag and drop",
    },
    {
      key: "select",
      name: "Select",
    },
  ];
  const handleAddButtonClick = React.useCallback((e) => {
    window.open("/s-crm/SaleActivityForm", "_blank");
  }, []);
  const searchEditorOptions = { placeholder: "Search column" };
  const columnChooserModeLabel = { "aria-label": "Column Chooser Mode" };
  const cellPrepared = (e) => {
    if (e.rowType === "data") {
      if (e.column.dataField === "PRIORITY") {
        e.cellElement.innerHTML =
          "<span class='status-button badge activity-" +
          e.data.ACTIVITY_NAME.toLowerCase().replace(/\s/g, "-") +
          "'><a href='Customer?customer_id=" +
          e.data.CRM_CUSCODE +
          "'  title='View' target='_blank' style='color: #FFFFFF;'>" +
          e.data.ACTIVITY_NAME +
          "</a></span>";
      }
      if (e.column.dataField === "CUSTOMER_NAME") {
        e.cellElement.innerHTML =
          "<span><a href='Customer?customer_id=" +
          e.data.CRM_CUSCODE +
          "' class='' title='View' target='_blank'>" +
          e.data.CUSTOMER_NAME +
          "</a></span>";
      }
    }
  };
  const customizeText = (cellInfo) => {
    if (
      cellInfo.value === "1900-01-01 00:00:00.000" ||
      cellInfo.value === "" ||
      cellInfo.value === null ||
      cellInfo.value === undefined
    ) {
      return "-";
    } else {
      return cellInfo.valueText;
    }
  };
  const isComplete = (status) =>
    status && ["3"].indexOf(status.trim().toUpperCase()) >= 0;
  const isRatingIconVisible = (e) => isComplete(e.row.data.STATUS_ID);

  const onExporting = (e: DataGridTypes.ExportingEvent) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet("Main sheet");
    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(
          new Blob([buffer], { type: "application/octet-stream" }),
          "SalesActivity.xlsx"
        );
      });
    });
  };
  //Column Chooser
  const [mode, setMode] = React.useState(columnChooserModes[1].key);
  const [searchEnabled, setSearchEnabled] = React.useState(true);
  const [allowSelectAll, setAllowSelectAll] = React.useState(true);
  const [selectByClick, setSelectByClick] = React.useState(true);
  const [recursive, setRecursive] = React.useState(true);
  const isDragMode = mode === columnChooserModes[0].key;
  const renderGridCell = (data: DataGridTypes.ColumnCellTemplateData) => (
    <a href={data.text} target="_blank" rel="noopener noreferrer">
      {data.text}
    </a>
  );
  const [showLog, setShowLog] = useState(false);
  const handleCloseLog = () => setShowLog(false);
  const handleShowLog = () => setShowLog(true);
  const [logData, setLogData] = useState([]);
  const onEditButtonClick = React.useCallback((e) => {
    const dataRow = e.row?.data;

    if (dataRow) {
      const salesActivityId = dataRow.SALES_ACTIVITY_ID;
      const customerCode = dataRow.CRM_CUSCODE;
      const activityName = dataRow.ACTIVITY_NAME;

      console.log("SALES_ACTIVITY_ID:", salesActivityId);
      console.log("customerCode:", customerCode);
      console.log("ACTIVITY_NAME:", activityName);

      // ส่งค่าที่ต้องการไปให้ function
      //fetchItemData(salesActivityId, customerCode);
      //fetchCommentItemData(salesActivityId, customerCode);
      setShowLog(true);
      // <CustomerActivityComment
      //       CRM_CUSCODE={customerCode}
      //       SALES_ACTIVITY_ID={salesActivityId}
      //       FROM="MODAL"
      //     />
    }
  }, []);
  const showLogData = true;
  const fetchItemData = async (salesActivityId, customerCode) => {
    const response = await fetch(
      api_path +
        "/customer/customer_activities.php?SALES_ACTIVITY_ID=" +
        salesActivityId +
        "&CRM_CUSCODE=" +
        customerCode
    );
    const data = await response.json();
    setLogData(data);
  };
  function DisplayLogData(props) {
    if (logData.length > 0) {
      return (
        <div>
          {showLogData ? (
            <>
              {logData.map((fdata) => {
                return (
                  <div>
                    <div>
                      <div class="timeline-item-date-wrapper">
                        <div className="timeline-date-v2-component">
                          <CalendarMonthIcon />{" "}
                          {dateFormat(
                            fdata.ACTIVITY_DATE,
                            "dd-mmm-yyyy H:mm:ss"
                          )}
                        </div>
                      </div>
                    </div>
                    <div>
                      <div>
                        <span
                          className={`status-button activity-topic activity-${fdata.ACTIVITY_NAME.toLowerCase().replace(
                            /\s/g,
                            "-"
                          )}`}
                        >
                          {fdata.ACTIVITY_NAME}
                        </span>

                        <p>
                          <b>Customer:</b>
                          {fdata.CUSTOMER_NAME}
                        </p>
                        <p>
                          <b>Topic:</b>
                          {fdata.TOPIC}
                        </p>
                        <p>
                          <b>Description:</b>
                          {fdata.DESCRIPTION}
                        </p>
                        <b>By: {fdata.CREATE_BY}</b>
                      </div>
                    </div>
                  </div>
                );
              })}
            </>
          ) : (
            <p>You cannot see the data</p>
          )}
        </div>
      );
    } else {
    }
  }

  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedActivityId, setSelectedActivityId] = useState(null);
  const [selectedCustomerCode, setSelectedCustomerCode] = useState(null);
  const [getFlag, setFlag] = useState(null);
  const onActivityButtonClick = (rowData, flag) => {
    const salesActivityId = rowData.SALES_ACTIVITY_ID;
    const customerCode = rowData.CRM_CUSCODE;
    const activityName = rowData.ACTIVITY_NAME;
    setSelectedActivityId(salesActivityId); // <-- ส่งเฉพาะ activity_id
    setSelectedCustomerCode(customerCode);
    setFlag(flag);
    setShowModal(true);
  };
  const onDeleteButtonClick = (rowData) => {
    const salesActivityId = rowData.SALES_ACTIVITY_ID;
    swal({
      title: "Are you sure to delete this activity id =" + salesActivityId,
      text: "",
      icon: "warning",
      dangerMode: true,
      buttons: true,
    }).then((isConfirm) => {
      if (isConfirm) {
        del(salesActivityId);
      }
    });
  };
  const del = async (id) => {
    try {
      const response = await axios.delete(
        api_path + `/customer_activities.php?id=${id}`
      );
      setLoadGrid(Math.floor(Math.random() * 20) + 1);
    } catch (error) {
      console.error(error);
    }
  };
  const fetchCustomer = () => {
    axios
      .get(`${api_path}/customer/customers.php?flag=all&SALES_CODE=${getEmpCode}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => setCustomerList(response.data))
      .catch((err) => console.log(err));
  };
  const handleStatusChange = (obj) => {
    setSelectStatus(obj.value);
    setStatus({ value: obj.value, label: obj.label });
  };
  const handleCustomerChange = (obj) => {
    setSelectCustomer(obj.CRM_CUSCODE);
    setCustomer({ value: obj.CRM_CUSCODE, label: obj.CUSTOMER_NAME });
  };
  useEffect(() => {
    if (getUserRole == 1) {
      setSelectSale(getCrmId);
      setSale({
        SALE_CODE: getCrmId,
        SALE_NAME: getUserID,
      });
    } else {
      fetchSale();
    }
  }, []);
  const fetchSale = async () => {
    try {
      const response = await axios.get(`${api_path}/GET_SALES.php`, {
        params: {
          role: getUserRole,
          user: getUserID,
        },
      });

      const saleData = response.data;
      setSaleList(saleData);
      // ✅ 1. ถ้ามีตัวเลือกเดียว ให้ตั้งค่าทันที
      if (saleData.length === 1) {
        setSelectSale(saleData[0].SALE_CODE);
        setSale({
          SALE_CODE: saleData[0].SALE_CODE,
          SALE_NAME: saleData[0].SALE_NAME,
        });
        return; // จบเลยไม่ต้องเช็คต่อ
      }

      // ✅ 2. ถ้ามี currentID (ผู้ใช้ล็อกอิน) ให้ตั้งเป็น default
      // const currentSale = saleData.find((item) => item.SALE_CODE === getCrmId);
      // if (currentSale) {
      //   console.log("current sales");
      //   console.log(currentSale.SALE_CODE + getUserID);
      //   setSelectSale(currentSale.SALE_CODE);
      //   setSale({
      //     SALE_CODE: currentSale.SALE_CODE,
      //     SALE_NAME: currentSale.SALE_NAME,
      //   });
      // }
    } catch (error) {
      console.error("Error fetching sales data:", error);
    }
  };
  const handleSaleChange = (obj) => {
    if (obj) {
      setSelectSale(obj.SALE_CODE);
      setSale({ SALE_CODE: obj.SALE_CODE, SALE_NAME: obj.SALE_NAME });
    } else {
      setSelectSale([]);
      setSale([]);
    }
    setTeam([]);
    setSelectTeam([]);
  };
  const teamList = [
    // { value: "", label: "All" },
    { value: "1", label: "Port Vanguard" },
    { value: "2", label: "Rail Breaker" },
  ];
  const handleTeamChange = (obj) => {
    setSelectTeam(obj.value);
    setTeam({ value: obj.value, label: obj.label });
    setSale([]);
    setSelectSale([]);
  };
  const stageMapping = {
    lead: 1,
    "in contact": 2,
    "sales visit": 3,
    "quotation sent": 4,
    negotiation: 5,
    "closed - won": 6,
    "closed - lost": 7,
  };
  const handleStageClick = (stageId) => {
    // const key = stageName.trim().toLowerCase(); // 👈 normalize
    // const stageId = stageMapping[key] || null;
    // console.log("🟦 Stage selected:", stageId);
    setSelectedStage(stageId);
  };
 const mockTickets = [
  { ID: 1, TICKET_NO: "TCK-2025-001", SUBJECT: "Cannot access email", CATEGORY: "IT Support", PRIORITY: "High", ASSIGNEE: "Somchai T.", STATUS: "Open", SUPPORT_BY: "Kornraphat (Aor)", CREATED_DATE: "2025-11-01 09:12", DUE_DATE: "2025-11-03 17:00", RESPONSE_TIME: "2h", CLOSE_TIME: null },
  { ID: 2, TICKET_NO: "TCK-2025-002", SUBJECT: "Software installation request", CATEGORY: "IT Support", PRIORITY: "Medium", ASSIGNEE: "Nattapong K.", STATUS: "In Progress", SUPPORT_BY: "Weerayut (Yutt)", CREATED_DATE: "2025-11-02 10:30", DUE_DATE: "2025-11-05 16:00", RESPONSE_TIME: "4h", CLOSE_TIME: null },
  { ID: 3, TICKET_NO: "TCK-2025-003", SUBJECT: "VPN not connecting", CATEGORY: "Network", PRIORITY: "High", ASSIGNEE: "Kornraphat C.", STATUS: "Open", SUPPORT_BY: "Aunyamanee (Nook)", CREATED_DATE: "2025-11-03 08:45", DUE_DATE: "2025-11-04 12:00", RESPONSE_TIME: "1h", CLOSE_TIME: null },
  { ID: 4, TICKET_NO: "TCK-2025-004", SUBJECT: "Request new monitor", CATEGORY: "Hardware", PRIORITY: "Low", ASSIGNEE: "Somchai T.", STATUS: "Closed", SUPPORT_BY: "Kornraphat (Aor)", CREATED_DATE: "2025-10-28 11:20", DUE_DATE: "2025-10-30 15:00", RESPONSE_TIME: "3h", CLOSE_TIME: "2025-10-30 14:50" },
  { ID: 5, TICKET_NO: "TCK-2025-005", SUBJECT: "Email not syncing on mobile", CATEGORY: "IT Support", PRIORITY: "Medium", ASSIGNEE: "Nattapong K.", STATUS: "In Progress", SUPPORT_BY: "Weerayut (Yutt)", CREATED_DATE: "2025-11-04 09:50", DUE_DATE: "2025-11-06 17:00", RESPONSE_TIME: "2h", CLOSE_TIME: null },
  { ID: 6, TICKET_NO: "TCK-2025-006", SUBJECT: "Password reset", CATEGORY: "IT Support", PRIORITY: "High", ASSIGNEE: "Kornraphat C.", STATUS: "Closed", SUPPORT_BY: "Aunyamanee (Nook)", CREATED_DATE: "2025-11-01 08:00", DUE_DATE: "2025-11-02 10:00", RESPONSE_TIME: "30m", CLOSE_TIME: "2025-11-02 09:45" },
  { ID: 7, TICKET_NO: "TCK-2025-007", SUBJECT: "Printer not working", CATEGORY: "Hardware", PRIORITY: "Medium", ASSIGNEE: "Somchai T.", STATUS: "Open", SUPPORT_BY: "Kornraphat (Aor)", CREATED_DATE: "2025-11-05 10:15", DUE_DATE: "2025-11-07 16:00", RESPONSE_TIME: "2h", CLOSE_TIME: null },
  { ID: 8, TICKET_NO: "TCK-2025-008", SUBJECT: "Software license renewal", CATEGORY: "IT Support", PRIORITY: "Low", ASSIGNEE: "Nattapong K.", STATUS: "Pending", SUPPORT_BY: "Weerayut (Yutt)", CREATED_DATE: "2025-11-06 11:00", DUE_DATE: "2025-11-15 17:00", RESPONSE_TIME: null, CLOSE_TIME: null },
  { ID: 9, TICKET_NO: "TCK-2025-009", SUBJECT: "Network slowdown", CATEGORY: "Network", PRIORITY: "High", ASSIGNEE: "Kornraphat C.", STATUS: "Open", SUPPORT_BY: "Aunyamanee (Nook)", CREATED_DATE: "2025-11-07 09:30", DUE_DATE: "2025-11-08 12:00", RESPONSE_TIME: "1h", CLOSE_TIME: null },
  { ID: 10, TICKET_NO: "TCK-2025-010", SUBJECT: "Laptop battery issue", CATEGORY: "Hardware", PRIORITY: "Medium", ASSIGNEE: "Somchai T.", STATUS: "In Progress", SUPPORT_BY: "Kornraphat (Aor)", CREATED_DATE: "2025-11-08 13:20", DUE_DATE: "2025-11-12 17:00", RESPONSE_TIME: "3h", CLOSE_TIME: null },
  { ID: 11, TICKET_NO: "TCK-2025-011", SUBJECT: "Request access to shared drive", CATEGORY: "IT Support", PRIORITY: "Low", ASSIGNEE: "Nattapong K.", STATUS: "Closed", SUPPORT_BY: "Weerayut (Yutt)", CREATED_DATE: "2025-11-09 09:00", DUE_DATE: "2025-11-10 16:00", RESPONSE_TIME: "1h", CLOSE_TIME: "2025-11-10 15:45" },
  { ID: 12, TICKET_NO: "TCK-2025-012", SUBJECT: "Projector not working", CATEGORY: "Hardware", PRIORITY: "Medium", ASSIGNEE: "Kornraphat C.", STATUS: "Open", SUPPORT_BY: "Aunyamanee (Nook)", CREATED_DATE: "2025-11-10 10:00", DUE_DATE: "2025-11-12 14:00", RESPONSE_TIME: "2h", CLOSE_TIME: null },
  { ID: 13, TICKET_NO: "TCK-2025-013", SUBJECT: "VPN password reset", CATEGORY: "Network", PRIORITY: "High", ASSIGNEE: "Somchai T.", STATUS: "Pending", SUPPORT_BY: "Kornraphat (Aor)", CREATED_DATE: "2025-11-11 08:45", DUE_DATE: "2025-11-13 12:00", RESPONSE_TIME: null, CLOSE_TIME: null },
  { ID: 14, TICKET_NO: "TCK-2025-014", SUBJECT: "Email forwarding issue", CATEGORY: "IT Support", PRIORITY: "Medium", ASSIGNEE: "Nattapong K.", STATUS: "In Progress", SUPPORT_BY: "Weerayut (Yutt)", CREATED_DATE: "2025-11-12 11:30", DUE_DATE: "2025-11-14 17:00", RESPONSE_TIME: "2h", CLOSE_TIME: null },
  { ID: 15, TICKET_NO: "TCK-2025-015", SUBJECT: "Mouse not working", CATEGORY: "Hardware", PRIORITY: "Low", ASSIGNEE: "Kornraphat C.", STATUS: "Closed", SUPPORT_BY: "Aunyamanee (Nook)", CREATED_DATE: "2025-11-13 09:15", DUE_DATE: "2025-11-14 16:00", RESPONSE_TIME: "1h", CLOSE_TIME: "2025-11-14 15:50" },
  { ID: 16, TICKET_NO: "TCK-2025-016", SUBJECT: "Request software upgrade", CATEGORY: "IT Support", PRIORITY: "High", ASSIGNEE: "Somchai T.", STATUS: "Open", SUPPORT_BY: "Kornraphat (Aor)", CREATED_DATE: "2025-11-14 10:00", DUE_DATE: "2025-11-16 17:00", RESPONSE_TIME: "3h", CLOSE_TIME: null },
  { ID: 17, TICKET_NO: "TCK-2025-017", SUBJECT: "Network cable replacement", CATEGORY: "Network", PRIORITY: "Medium", ASSIGNEE: "Nattapong K.", STATUS: "In Progress", SUPPORT_BY: "Weerayut (Yutt)", CREATED_DATE: "2025-11-15 11:00", DUE_DATE: "2025-11-18 16:00", RESPONSE_TIME: "2h", CLOSE_TIME: null },
  { ID: 18, TICKET_NO: "TCK-2025-018", SUBJECT: "Monitor flickering", CATEGORY: "Hardware", PRIORITY: "Medium", ASSIGNEE: "Kornraphat C.", STATUS: "Open", SUPPORT_BY: "Aunyamanee (Nook)", CREATED_DATE: "2025-11-16 09:00", DUE_DATE: "2025-11-17 15:00", RESPONSE_TIME: "1h", CLOSE_TIME: null },
  { ID: 19, TICKET_NO: "TCK-2025-019", SUBJECT: "Cannot print PDF", CATEGORY: "IT Support", PRIORITY: "Low", ASSIGNEE: "Somchai T.", STATUS: "Pending", SUPPORT_BY: "Kornraphat (Aor)", CREATED_DATE: "2025-11-17 10:00", DUE_DATE: "2025-11-19 16:00", RESPONSE_TIME: null, CLOSE_TIME: null },
  { ID: 20, TICKET_NO: "TCK-2025-020", SUBJECT: "Request new keyboard", CATEGORY: "Hardware", PRIORITY: "Low", ASSIGNEE: "Nattapong K.", STATUS: "Closed", SUPPORT_BY: "Weerayut (Yutt)", CREATED_DATE: "2025-11-18 09:30", DUE_DATE: "2025-11-20 15:00", RESPONSE_TIME: "2h", CLOSE_TIME: "2025-11-20 14:50" }
];
  const dataSource = useMemo(() => mockTickets, []);
  const allowedRoles = ["3", "7", "8", "9", "14"]; // ใส่ role_id ที่อนุญาต
  // console.log("getUserRole:", getUserRole, typeof getUserRole);
  if (!getUserRole) return null; // 👈 อย่า render grid ถ้ายังไม่มี role
  const updateGridData = () => {
    setLoadGrid(Math.floor(Math.random() * 20) + 1);
  };

  return (
    <Container maxWidth="xl">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          &nbsp;
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={9}>
          <label className="head">Ticket</label>
        </Grid>
        <Grid
          item
          xs={12}
          sm={3}
          style={{ display: "flex" }}
          justify="flex-end"
        >
          <Button1
            className="addBtn"
            type="button"
            variant="contained"
            color="primary"
            onClick={onActivityButtonClick}
          >
            New
          </Button1>
        </Grid>
      </Grid>
      <AddAssetModal
        key={Date.now()} // 👈 ทำให้ modal รีเซ็ตทุกครั้งที่เลือกแถวใหม่
        show={showModal}
        ROLE_ID={getUserRole}
        ACTIVITY_ID={selectedActivityId}
        CUSTOMER_CODE={selectedCustomerCode}
        FLAG={getFlag}
        onClose={() => setShowModal(false)}
        PAGE="GRID"
        onSaveSuccess={updateGridData}
      />
      <Modal
        className="modal"
        show={showLog}
        onHide={handleCloseLog}
        backdrop="static"
        keyboard={false}
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>View Activity</Modal.Title>
          <Button1 variant="secondary" onClick={handleCloseLog}>
            Close
          </Button1>
        </Modal.Header>
        <Modal.Body>
          <Grid container>
            <br />
            <DisplayLogData logData={logData} />
          </Grid>
        </Modal.Body>
        <Modal.Footer>
          <Button1 variant="secondary" onClick={handleCloseLog}>
            Close
          </Button1>
        </Modal.Footer>
      </Modal>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={2}>
          <label>License Code</label>
          <TextField
            size="small"
            name="GET_SERIAL"
            variant="outlined"
            fullWidth
            id="GET_SERIAL"
            value={GET_SERIAL}
            onChange={(e) => SET_SERIAL(e.target.value)}
          />
        </Grid>

        <Grid item xs={12} sm={2}>
          <label>Type</label>
          <Select
            placeholder="Select"
            value={getStatus}
            options={statusList}
            onChange={handleStatusChange}
            getOptionLabel={(x) => x.label}
            getOptionValue={(x) => x.value}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>Status</label>
          <Select
            placeholder="Select"
            value={customer}
            options={customerList}
            onChange={handleCustomerChange}
            getOptionLabel={(x) => x.CUSTOMER_NAME}
            getOptionValue={(x) => x.CRM_CUSCODE}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>Owner</label>
          <Select
            placeholder="Select"
            value={customer}
            options={customerList}
            onChange={handleCustomerChange}
            getOptionLabel={(x) => x.CUSTOMER_NAME}
            getOptionValue={(x) => x.CRM_CUSCODE}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <div className="paddingSearchButton">&nbsp;</div>
          <Button1
            className="searchButton"
            type="button"
            variant="contained"
            color="primary"
            onClick={handleSearch}
          >
            Search
          </Button1>
          &nbsp;&nbsp;&nbsp;
          <Button1
            className="searchButton"
            type="button"
            variant="outlined"
            color="primary"
            onClick={handleClearInputClick}
          >
            Clear Filter
          </Button1>
        </Grid>

        <Grid item xs={12} sm={12}>
          <LicensesSummaryPage
            onStageClick={handleStageClick}
            userId={getCrmId}
            salesId={getSelectSale}
            datefrom={getDateFrom}
            dateto={getDateTo}
            salesTeam={getSelectTeam}
            salesRole={getUserRole}
          />
        </Grid>
      </Grid>
      <Grid container className={classes.root}>
        <DataGrid
          dataSource={mockTickets}
          keyExpr="ID"
          showBorders={true}
          rowAlternationEnabled={true}
            // onCellPrepared={cellPrepared}
        >
          <Scrolling
            rowRenderingMode="virtual"
            showScrollbar="always"
            useNative="false"
            scrollByThumb="true"
          ></Scrolling>

          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <HeaderFilter visible={true} />
          <Selection mode="single" />
          <SearchPanel
            visible={true}
            width={240}
            placeholder="Full Text Search..."
          />

          <Column dataField="TICKET_NO" caption="Ticket No." />
          <Column dataField="SUBJECT" caption="Subject" />
          <Column dataField="CATEGORY" caption="Category" />
          <Column dataField="PRIORITY" caption="Priority" />
          <Column dataField="ASSIGNEE" caption="Assignee" />
          <Column dataField="STATUS" caption="Status" />
          <Column dataField="SUPPORT_BY" caption="Support" />
          <Column dataField="CREATED_DATE" caption="Create Date" />
          <Column dataField="DUE_DATE" caption="Due Date" />
          <Column dataField="RESPONSE_TIME" caption="Response Time" />
          <Column dataField="CLOSE_TIME" caption="Close Time" />
          <Column
            caption="Edit"
            width={50}
            alignment="center"
            cellRender={(cellData) => {
              return (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    height: "100%",
                  }}
                >
                  <button
                    style={{
                      backgroundColor: "GRAY",
                      color: "white",
                      border: "none",
                      padding: "5px 10px",
                      borderRadius: "4px",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    title="Edit Activity"
                    onClick={() => onActivityButtonClick(cellData.data, "EDIT")}
                  >
                    <span
                      className="dx-icon dx-icon-edit"
                      style={{ fontSize: "12px" }}
                    ></span>
                  </button>
                </div>
              );
            }}
          />
          <Column
            caption="Copy"
            width={50}
            alignment="center"
            cellRender={(cellData) => {
              return (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    height: "100%",
                  }}
                >
                  <button
                    style={{
                      backgroundColor: "#007bff",
                      color: "white",
                      border: "none",
                      padding: "5px 10px",
                      borderRadius: "4px",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    title="Copy Activity"
                    onClick={() => onActivityButtonClick(cellData.data, "COPY")}
                  >
                    <span
                      className="dx-icon dx-icon-copy"
                      style={{ fontSize: "12px" }}
                    ></span>
                  </button>
                </div>
              );
            }}
          />
          <Column
            caption="Del"
            width={50}
            alignment="center"
            cellRender={(cellData) => {
              return (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    height: "100%",
                  }}
                >
                  <button
                    style={{
                      backgroundColor: "#F44336",
                      color: "white",
                      border: "none",
                      padding: "5px 10px",
                      borderRadius: "4px",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    title="Delete Activity"
                    onClick={() => onDeleteButtonClick(cellData.data)}
                  >
                    <span
                      className="dx-icon dx-icon-trash"
                      style={{ fontSize: "12px" }}
                    ></span>
                  </button>
                </div>
              );
            }}
          />
          <LoadPanel enabled={true} />
          <ColumnChooser enabled={true} mode={mode}>
            <Position
              my="right top"
              at="right bottom"
              of=".dx-datagrid-column-chooser-button"
            />

            <ColumnChooserSearch
              enabled={searchEnabled}
              editorOptions={searchEditorOptions}
            />

            <ColumnChooserSelection
              allowSelectAll={allowSelectAll}
              selectByClick={selectByClick}
              recursive={recursive}
            />
          </ColumnChooser>
          <LoadPanel enabled={true} />
          <Export enabled={true} allowExportSelectedData={true} />
          <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
          <Paging defaultPageSize={25} />
        </DataGrid>
      </Grid>
    </Container>
  );
}
